import { createApp } from 'vue'
import App from './App.vue'

// Vuetifyの追加
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import '@mdi/font/css/materialdesignicons.css' // Material Design Iconsをインポート

// ロガーサービスをインポート
import logger, { DEBUG_MODE } from './services/logger'

// カスタムテーマを作成
const lightTheme = {
  dark: false,
  colors: {
    primary: '#e9d0ca', // BKMSのブランドカラー
    secondary: '#424242',
    accent: '#8c9eff',
    error: '#ff5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
    background: '#f5f5f5'
  }
}

// ロガーを初期化（保存されたログレベルを読み込む）
logger.loadLogLevel();

// 本番環境の場合はコンソールログを制限
if (process.env.NODE_ENV === 'production') {
  // 本番環境ではWARNレベル以上のみ表示（ただしデバッグモードが有効の場合は例外）
  if (!DEBUG_MODE) {
    logger.setLogLevel('WARN');
  }
  
  // オプション: すべてのconsole.* 呼び出しを制御（既存のconsole.logも含む）
  // logger.overrideConsole(true);
}

// ハードコーディングされたデバッグモードフラグが有効の場合
if (DEBUG_MODE) {
  logger.setLogLevel('DEBUG');
  logger.info('デバッグモードが有効になっています');
  
  // 必要に応じてconsole.*メソッドを上書き
  // logger.overrideConsole(true);
}

// Vuetifyインスタンスを作成
const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'lightTheme',
    themes: {
      lightTheme,
    },
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
})

// VuetifyをVueアプリケーションに設定
const app = createApp(App)
app.use(vuetify)
app.mount('#app')
